import { Droplets, Timer, Target } from "lucide-react";

const steps = [
  {
    step: "01",
    icon: Droplets,
    title: "Mix one scoop",
    description: "Add one scoop to 8-12oz of cold water. Shake or stir until fully dissolved."
  },
  {
    step: "02",
    icon: Timer,
    title: "Feel it within 20 mins",
    description: "The nootropic blend begins working quickly, delivering smooth, focused energy."
  },
  {
    step: "03",
    icon: Target,
    title: "Stay in the zone for hours",
    description: "Experience sustained mental clarity and focus for 4-6 hours without the crash."
  }
];

const HowItWorks = () => {
  return (
    <section 
      className="py-20 md:py-28"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-nukleus-lilac mb-4 block">
            Simple & Effective
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white tracking-tight">
            How It Works
          </h2>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {steps.map((step, index) => (
            <div
              key={index}
              className="group relative bg-nukleus-card rounded-2xl p-8 border border-white/5 hover:border-nukleus-violet/30 transition-all duration-300 card-hover"
              data-testid={`step-${index + 1}`}
            >
              {/* Step Number */}
              <span className="text-5xl font-black text-white/5 absolute top-4 right-6">
                {step.step}
              </span>
              
              {/* Icon */}
              <div className="w-14 h-14 rounded-xl bg-nukleus-violet/10 flex items-center justify-center mb-6 group-hover:bg-nukleus-violet/20 transition-colors">
                <step.icon className="w-6 h-6 text-nukleus-violet" />
              </div>
              
              {/* Content */}
              <h3 className="text-xl font-semibold text-white mb-3">
                {step.title}
              </h3>
              <p className="text-white/50 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
